"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterStore = exports.setFilterStore = void 0;
var globalStore;
function setFilterStore(newStore) {
    globalStore = newStore;
}
exports.setFilterStore = setFilterStore;
function getFilterStore(optionalStore) {
    var resolvedStore = optionalStore || globalStore;
    if (!resolvedStore) {
        throw new Error('A store must be set with setFilterStore');
    }
    return resolvedStore;
}
exports.getFilterStore = getFilterStore;
